import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const e=i("north_korea",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M24 4.5L0 4.5L0 20.5L24 20.5L24 4.5Z"
                fill="#024FA2" />
            <path
                d="M24 7.16699L0 7.16699L0 17.8337H24L24 7.16699Z"
                fill="white" />
            <path
                d="M24 7.61035L0 7.61035L0 17.3881H24L24 7.61035Z"
                fill="#ED1C27" />
            <path
                d="M12.0002 16.6136C14.2722 16.6136 16.1141 14.7717 16.1141 12.4997C16.1141 10.2276 14.2722 8.38574 12.0002 8.38574C9.7281 8.38574 7.88623 10.2276 7.88623 12.4997C7.88623 14.7717 9.7281 16.6136 12.0002 16.6136Z"
                fill="white" />
            <path
                d="M13.4515 12.969L15.7913 11.272L12.8962 11.272L12.0014 8.51562L11.1066 11.272H8.21143L10.5512 12.969L9.65645 15.7253L12.0014 14.0232L14.3463 15.7253L13.4515 12.969Z"
                fill="#ED1C27" />
        </svg>
    `),p=i("north_korea_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66541)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M24 0.5L0 0.5L0 24.5L24 24.5L24 0.5Z"
                    fill="#024FA2" />
                <path
                    d="M24 4.5L0 4.5L0 20.5L24 20.5L24 4.5Z"
                    fill="white" />
                <path
                    d="M24 5.16602L0 5.16602L0 19.8327L24 19.8327L24 5.16602Z"
                    fill="#ED1C27" />
                <path
                    d="M6.66536 17.8327C9.61088 17.8327 11.9987 15.4449 11.9987 12.4993C11.9987 9.55383 9.61088 7.16602 6.66536 7.16602C3.71985 7.16602 1.33203 9.55383 1.33203 12.4993C1.33203 15.4449 3.71985 17.8327 6.66536 17.8327Z"
                    fill="white" />
                <path
                    d="M8.54724 13.1073L11.5806 10.9073L7.82724 10.9073L6.66724 7.33398L5.50724 10.9073H1.75391L4.78724 13.1073L3.62724 16.6807L6.66724 14.474L9.70724 16.6807L8.54724 13.1073Z"
                    fill="#ED1C27" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66541">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{e as NorthKorea,p as NorthKoreaRounded};
